(function () {
  angular
    .module("akitabox.mobile.directives.textCard")
    .controller("AbmTextCardController", AbmTextCardController);

  /**
   * @ngdoc controller
   * @module akitabox.mobile.directives.textCard
   * @name AbmTextCardController
   *
   * @description
   * Controller for the text card directive
   *
   * @ngInject
   */
  function AbmTextCardController($mdDialog, $q, $timeout) {
    var self = this;

    // Attributes
    self.expanded = false;
    self.moreToShow = false;
    self.showPlaceholder = false;
    self.deletable = false;

    // Functions
    self.edit = edit;
    self.save = save;

    function save(model) {
      if (angular.isEmpty(model)) {
        self.ngModel = null;
        self.showPlaceholder = true;
      } else {
        self.ngModel = model;
        self.showPlaceholder = false;
      }

      return $timeout(function () {
        return $q.resolve(self.onSave());
      }).then(self.updateContent);
    }

    function edit() {
      $mdDialog.show({
        templateUrl:
          "app/mobile/directives/text-card/dialog/text-card.dialog.html",
        controller: "TextCardDialogController",
        bindToController: true,
        controllerAs: "dialog",
        fullscreen: true,
        locals: {
          label: self.label,
          ngModel: self.ngModel,
          update: self.save,
          height: self.contentHeight,
        },
      });
    }
  }
})();
